module.exports = __webpack_public_path__ + "files/a9f546dd025d6afa339c171f13461d12.png";